export default function getAppUrlWithDomain(url: string, domain?: string) {
  // @ts-ignore
  const prefix = domain || import.meta.env?.VITE_PLATFORM_URL;
  return prefix ? `${prefix}${url}` : url;
}
